/* eslint-disable no-new */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react';
import More from '@spectrum-icons/workflow/MoreSmallList';
import { Button } from '@adobe/react-spectrum';
import { ReactComponent as LinkedIn } from '../../Icons/LinkedIn.svg';
import { ReactComponent as Twitter } from '../../Icons/Twitter.svg';
import { ReactComponent as TikTok } from '../../Icons/TikTok.svg';
import { ReactComponent as Youtube } from '../../Icons/YouTube.svg';
import { ReactComponent as Facebook } from '../../Icons/Facebook.svg';
import { ReactComponent as Instagram } from '../../Icons/Instagram.svg';

const SocialMediaIcons = ({ apiResponse, handleCardClick, detailsPage = false }) => {
  const socialMediaKeys = [
    'linkedInUrl',
    'twitterHandle',
    'facebookUrl',
    'instagramUrl',
    'youtubeChannels',
    'tiktok',
  ];

  const getIcon = (key) => {
    switch (key) {
      case 'facebookUrl':
        return <Facebook width={24} height={24} />;
      case 'twitterHandle':
        return <Twitter width={24} height={24} />;
      case 'instagramUrl':
        return <Instagram width={24} height={24} />;
      case 'linkedInUrl':
        return <LinkedIn width={24} height={24} />;
      case 'youtubeChannels':
        return <Youtube width={24} height={24} />;
      case 'tiktok':
        return <TikTok width={24} height={24} />;
      default:
        return null;
    }
  };
  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };
  const socialMediaWithUrls = socialMediaKeys.filter((key) => apiResponse[key]);
  const maxIconsToShow = detailsPage ? 6 : 4;
  return (
    <div style={{
      display: 'flex', gap: '10px', alignItems: 'center', marginTop: socialMediaWithUrls.length > 0 ? '6px' : '0px',
    }}
    >
      {socialMediaWithUrls.slice(0, socialMediaWithUrls.length > maxIconsToShow ? maxIconsToShow : socialMediaWithUrls.length).map((key) => {
        const hrefValue = apiResponse[key];
        const finalHref = isValidUrl(hrefValue) ? hrefValue : `https://${hrefValue}`;
        return (
          <a
            title={key}
            href={finalHref}
            style={{
              cursor: 'pointer',
              textDecoration: 'none',
              color: 'inherit',
            }}
            target="_blank"
            rel="noreferrer"
          >
            {getIcon(key)}
          </a>
        );
      })}
      {!detailsPage && socialMediaWithUrls.length > maxIconsToShow && (
      <Button onPress={handleCardClick} UNSAFE_style={{ border: 'none', cursor: 'pointer' }}>
        <More width={24} height={24} />
      </Button>
      )}
    </div>
  );
};

export default SocialMediaIcons;
